export default __webpack_public_path__ + "static/media/eth.df265e36.svg";